module.exports = __webpack_public_path__ + "static/media/pixabay.c39b5680.jpg";